import { render } from "./BodyGirthView.vue?vue&type=template&id=239827aa&scoped=true"
import script from "./BodyGirthView.vue?vue&type=script&lang=js"
export * from "./BodyGirthView.vue?vue&type=script&lang=js"

import "./BodyGirthView.vue?vue&type=style&index=0&id=239827aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-239827aa"]])

export default __exports__